/**
 * documents.js
 * ------------
 * GED — documents d'etablissement.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── GED (documents d'établissement, /api/ged/documents/) ── */

/** GET /ged/documents/ — documents visibles par le rôle, scope établissement. */
export async function getDocumentsGED(params = {}) {
  const { data } = await axiosClient.get("/ged/documents/", { params });
  return Array.isArray(data) ? data : data?.results || [];
}

/**
 * POST /ged/documents/ — téléversement (multipart).
 * @param {{fichier: File, titre: string, type_document: string, description?: string}} payload
 */
export async function uploadDocumentGED(payload) {
  const fd = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v != null && v !== "") fd.append(k, v);
  });
  const { data } = await axiosClient.post("/ged/documents/", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

/** DELETE /ged/documents/<id>/ */
export async function supprimerDocumentGED(id) {
  await axiosClient.delete(`/ged/documents/${id}/`);
}
